module.exports = __webpack_public_path__ + "img/sub-nav-links-chevy.bab40133.png";